import type { Route } from "./+types/_index";
import { useLoaderData } from "react-router";
import { Activity } from "../components/Activity";
import LandingPage from "../landing/LandingPage";
import { SITE_URL } from "~/lib/seo/jsonld";
import { socialMeta, DEFAULT_OG_IMAGE } from "~/lib/seo/social-meta";

export function meta(_: Route.MetaArgs) {
  const title = "Emulator Arcade — Play NES, SNES, Game Boy & more inside Discord";
  const description =
    "Boot up an NES, SNES, Game Boy, Genesis or a dozen other retro classics right inside a Discord voice channel. Bring your own ROM, hit play, pass the controller around the call — no install required.";
  return [
    { title },
    { name: "description", content: description },
    {
      name: "keywords",
      content:
        "Discord emulator, retro games Discord, NES Discord, SNES Discord, Game Boy Discord, play retro games in Discord, Discord activity games, browser emulator, EmulatorJS, RetroArch",
    },
    ...socialMeta({
      title,
      description,
      url: SITE_URL,
      image: DEFAULT_OG_IMAGE,
      imageAlt: "Emulator Arcade",
    }),
  ];
}

export function loader({ request }: Route.LoaderArgs) {
  // Detect the Discord Activity context server-side (the Embedded App SDK adds a
  // `frame_id` query param when running inside Discord). Reading it here in the
  // loader avoids touching `window` during SSR.
  const inDiscord = new URL(request.url).searchParams.has("frame_id");
  return { inDiscord, discordClientId: process.env.DISCORD_CLIENT_ID ?? "" };
}

export default function Home() {
  const { inDiscord, discordClientId } = useLoaderData<typeof loader>();
  return inDiscord ? <Activity clientId={discordClientId} /> : <LandingPage />;
}
